import { graphql, navigate } from 'gatsby'
import * as PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import asTemplate from '../../root/Template'
import { withTransformer } from '../../utils/GatsbyUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { getTranslationFunction } from '../../utils/TranslationUtils'

import styles from './styles'
import {SectionContainer, MarkdownText, ArrowLink, SectionUptitle} from '../../components'
import HomeContact from "../Homepage/HomeContact";


const COLOR_SEED = 56080331684335

const mapSelectors = () => ({
  //
})

const mapActions = dispatch => ({
  //
})

const transformer = (data) => {
  const { contentfulLocale } = data
  return {
    t: getTranslationFunction(contentfulLocale.texts)
  }
}

const decorators = [
  asTemplate,
  withTransformer(transformer),
  connect(mapSelectors, mapActions),
  memoized,
]

function DemoTemplate(props) {
  const { t, locale } = props

  return (
    <>
      <div className="content">
        <SectionContainer className="container">
          <ArrowLink
            className="link"
            onClick={() => navigate(-1)}
            label={"Spin démo"}
            icon="/images/icons/arrow-left-white.svg"
          />
          <script type="module" src="https://unpkg.com/@splinetool/viewer@1.0.78/build/spline-viewer.js"></script>
          <spline-viewer hint loading-anim-type="spinner-big-light" url="https://prod.spline.design/jKCFNOjrpFYbeL44/scene.splinecode"></spline-viewer>
        </SectionContainer>
      </div>
      <HomeContact
        title={t('haveAnIdea')}
        contactEmail={t('contactEmail')}
      />s
      <style jsx>{styles}</style>
    </>
  )
}

DemoTemplate.propTypes = {
  locale: PropTypes.string
}

DemoTemplate.defaultProps = {
  locale: ''
}

DemoTemplate = chainDecorators(decorators, DemoTemplate)

export default DemoTemplate

export const query = graphql`
  query($langKey: String!) {
    allContentfulDomain(filter: { node_locale: { eq: $langKey } }) {
      edges {
        node {
          ...bbsContentfulDomain
        }
      }
    }
    contentfulLocale (node_locale: {eq: $langKey}){
      texts {
        haveAnIdea
        contactEmail
      }
    }
  }
`
